import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PaymentField } from "./PaymentField";
import { ClickToPayConfig } from "./types";

type ClickToPayFormProps = {
    config: ClickToPayConfig;
    onChange: (update: Partial<ClickToPayConfig>) => void;
};

export function ClickToPayForm({ config, onChange }: ClickToPayFormProps) {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div data-testid="clicktopay-form" className="payment-form__clz">
            <PaymentField
                testId="clicktopay-user"
                label={t("User")}
                value={config.USER}
                onChange={(USER) => onChange({ USER })}
            />
            <PaymentField
                testId="clicktopay-password"
                label={t("Password")}
                value={config.PASSWORD}
                onChange={(PASSWORD) => onChange({ PASSWORD })}
                isPassword
                showPassword={showPassword}
                toggleShowPassword={() => setShowPassword(!showPassword)}
            />
        </div>
    );
}
